import Api from '@/services/Api'

const HEADERURL = 'wms/facturas/';

export default {

    fetch(params) {
        return Api().get(HEADERURL, {
            params: params
        });
    },

    getById(id) {

        return Api().get(`${HEADERURL}${id}`);

    },

    sincronizarPreciosOC(id) {
        return Api().post(`${HEADERURL}${id}/sincronizar_precios_oc/`);
    },

    getMotivosMalEstado() {
        return Api().get(`${HEADERURL}motivos_mal_estado/`);
    },

}